var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "#F9B218",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.1122 3.44868C23.575 3.39971 23.1 3.79546 23.051 4.33257L22.9216 5.75195C20.7264 2.30439 16.9156 0 12.5001 0C7.75008 0 3.564 2.71104 1.48597 6.77998C1.24066 7.2603 1.43119 7.84853 1.91151 8.09385C2.39193 8.33916 2.98006 8.14868 3.22538 7.66831C4.98402 4.22476 8.51561 1.95312 12.5001 1.95312C16.1318 1.95312 19.4093 3.84429 21.2869 6.80703L19.8945 5.81255C19.4556 5.49912 18.8456 5.60078 18.5322 6.03965C18.2188 6.47856 18.3204 7.08843 18.7593 7.4019L22.9817 10.4176C23.6006 10.8587 24.4541 10.4549 24.5218 9.71157L24.996 4.50991C25.045 3.97275 24.6493 3.49766 24.1122 3.44868Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0886 16.9061C22.6082 16.6609 22.02 16.8514 21.7747 17.3317C20.0161 20.7752 16.4845 23.0469 12.4999 23.0469C8.86826 23.0469 5.59082 21.1557 3.71318 18.193L5.10561 19.1874C5.54453 19.5009 6.15439 19.3992 6.46787 18.9603C6.78129 18.5214 6.67963 17.9116 6.24077 17.5981L2.01836 14.5824C1.40708 14.1457 0.546626 14.5374 0.478267 15.2884L0.00409706 20.4901C-0.0448776 21.0272 0.350874 21.5023 0.887935 21.5513C1.42573 21.6001 1.90019 21.204 1.94912 20.6674L2.07851 19.248C4.27373 22.6956 8.08447 25 12.4999 25C17.25 25 21.4361 22.289 23.5141 18.22C23.7594 17.7397 23.5689 17.1515 23.0886 16.9061Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.62222cc781ad136cdb9d30af5f5537f0.svg";
export { ForwardRef as ReactComponent };